/* eslint no-underscore-dangle: 0 */
import svgxhr from "webpack-svgstore-plugin/src/helpers/svgxhr";

if (process.env.NODE_ENV === "storybook-production") global.baseUrl = "/rialto-ui/";

var __svg__ = { // eslint-disable-line
  path: "../src/assets/icons/*.svg",
  name: "icons_[hash].svg",
};

svgxhr(__svg__);
